import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Eczema forms
   */

  {
    // 1
    field: 'eczAffected',
    label: 'Please upload pictures of the affected areas .',
    type: 'image_list',
    answer: {
      option: {
        label: 'Affected Area',
        buttonLabel: 'Choose File',
        addLabel: '+Add another',
        resourceId: 'eczAffectedArea',
        limit: 3,
        required: true
      }
    }
  },
  {
    // 2
    field: 'eczDiagnosed',
    label: 'Have you ever been diagnosed by a doctor with eczema or psoriasis?',
    type: 'polar_check',
    answer: {
      label: 'Were you treated for it?',
      type: 'radio',
      name: 'eczTreatedOption',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label: 'And did you receive any of these treatments?',
            type: 'multi_select',
            level: 'child',
            options: [
              { key: 'anthralin', value: 'Anthralin' },
              {
                key: 'diprosone',
                value: 'Diprosone (betamethasone dipropionate 0.05% lotion)'
              },
              {
                key: 'betamethasone',
                value: 'Betamethasone valerate 0.1% lotion'
              },
              { key: 'clobetasol', value: 'Clobetasol propionate 0.05%' },
              { key: 'mometasone', value: 'Mometasone furoate 0.1%' },
              { key: 'salicylic', value: 'Salicylic acid' },
              { key: 'tazaortene', value: 'Tazaortene' },
              {
                key: 'otherTreatments',
                value: 'Other',
                uncheckOthers: true,
                answer: {
                  type: 'text',
                  name: 'otherTreatmentsDesc',
                  placeholder: 'Please type here...'
                }
              }
            ]
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    // 3
    field: 'eczMedical',
    label: 'Have you ever been diagnosed with another medical condition?',
    type: 'polar_check',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'obesity', value: 'Obesity' },
        { key: 'diabetes', value: 'Diabetes' },
        { key: 'mood', value: 'Mood disorders such as anxiety or depression' },
        { key: 'inflammatory', value: 'Inflammatory bowel disease' },
        { key: 'juvenile', value: 'Juvenile idiopathic arthritis' },
        { key: 'fatty', value: 'Fatty liver disease' },
        { key: 'heartDisease', value: 'Heart disease' },
        {
          key: 'bloodPressure',
          value: 'High blood pressure',
          answer: {
            label: 'Please provide current readings',
            type: 'text',
            name: 'currentBP',
            placeholder: 'Please type here...'
          }
        }
      ]
    }
  },
  {
    // 4
    field: 'eczDescSkin',
    label: 'How would you describe your skin?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'veryDry', value: 'very dry' },
        { key: 'dry', value: 'dry' },
        { key: 'average', value: 'average' },
        { key: 'oily', value: 'oily' },
        { key: 'veryOily', value: 'very oily' },
        { key: 'sensitive', value: 'sensitive' },
        { key: 'combination', value: 'combination' },
        { key: 'other', value: 'other' }
      ]
    }
  },
  {
    // 5
    field: 'eczSPF',
    label: 'Do you put sunscreen, or anything with SPF, on your face?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'always', value: 'always' },
        { key: 'mostOfTime', value: 'most of the time' },
        { key: 'sometimes', value: 'sometimes' },
        { key: 'never', value: 'never' }
      ]
    }
  },
  {
    // 6
    field: 'eczBodyEffected',
    label: 'What parts of your body are affected?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'face', value: 'face' },
        { key: 'back', value: 'back' },
        { key: 'chest', value: 'chest' },
        { key: 'other', value: 'other' }
      ]
    }
  },
  {
    // 7
    field: 'eczPregnant',
    label:
      'Are you pregnant, breastfeeding or planning to become pregnant in the near future?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'pregnantYes', value: 'Yes' },
        { key: 'pregnantNo', value: 'No' }
      ]
    }
  },
  {
    // 8
    field: 'eczReaction',
    label:
      "Have you had a reaction to any of the topical products you've used for your skin in the past?",
    type: 'polar_check',
    answer: {
      label:
        'Please describe the type of reaction you had, and as much detail as you can about the product that caused it.',
      type: 'text',
      name: 'eczReactionDesc',
      rows: 5,
      placeholder: 'Please type here...'
    }
  },
  {
    // 9
    field: 'eczDiagnosedAny',
    label: 'Have you ever been diagnosed with any of the following:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'acne', value: 'Acne' },
        { key: 'perioral', value: 'Perioral dermatitis' },
        { key: 'facial', value: 'Facial eczema' },
        { key: 'psoriasis', value: 'Psoriasis' },
        { key: 'bacterial', value: 'Bacterial or fungal folliculitis' },
        {
          key: 'noneDiagnosed',
          value: "No, I've never been diagnosed with any of these.",
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 10
    field: 'eczGoalsSkin',
    label: 'What goals would you like to achieve for you and your skin?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'goalsSkinDesc',
      rows: 5,
      placeholder: 'Please type here...'
    }
  },
  {
    // 11
    field: 'eczApplySkin',
    label: 'Select all that apply for your skin:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'brightRed',
          value: 'Bright red and inflamed areas of the skin'
        },
        { key: 'redRaised', value: 'Red, raised areas of the skin' },
        {
          key: 'silveryWhite',
          value: 'Silvery-white flakes, called scales'
        },
        { key: 'smallRed', value: 'Small red spots on skin' },
        { key: 'whitePusFilled', value: 'White, pus-filled blisters' },
        { key: 'dryThickened', value: 'Dry and thickened skin' },
        { key: 'thickening', value: 'Thickening of nails' },
        { key: 'yellow', value: 'Yellow brown spots on nails' },
        {
          key: 'redShiny',
          value: 'Red and shiny/ glossy areas of the skin'
        },
        {
          key: 'circularPatches',
          value:
            'Circular patches where skin is paler around a plaque (a slightly raised, solid patch of skin) in a ring'
        },
        { key: 'joint', value: 'Joint stiffness, mainly in the morning' }
      ]
    }
  },
  {
    // 12
    field: 'eczValuable',
    label:
      'Please list anything else you feel may be valuable for the doctor evaluating your submission.',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'obesity', value: 'Obesity' },
        { key: 'diabetes', value: 'Diabetes' },
        {
          key: 'mood',
          value: 'Mood disorders such as anxiety or depression'
        },
        { key: 'inflammatory', value: 'Inflammatory bowel disease' },
        { key: 'juvenile', value: 'Juvenile idiopathic arthritis' },
        { key: 'fatty', value: 'Fatty liver disease' },
        { key: 'heartDisease', value: 'Heart disease' },
        {
          key: 'bloodPressure',
          value: 'High blood pressure',
          answer: {
            label: 'Please provide current readings',
            type: 'text',
            name: 'currentBP',
            placeholder: 'Please type here...'
          }
        },
        {
          key: 'noneValuable',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },

  {
    // 13
    field: 'eczAnythingElse',
    label: 'Is there anything else you would like the doctor to know?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'eczAnythingElseDesc',
      placeholder: 'Please type here...'
    }
  }
];

export default questionsModels;
